/*
 * Accordion "Steps" style (blocks/accordion.liquid → Style: Steps).
 * Keeps one row open at a time; on devices with a mouse, hovering a step's
 * title opens it. Rows stay native <details>/<summary>, so click, Enter and
 * Space still work and the open state is announced to assistive tech.
 */
(() => {
  if (window.vrAccordionSteps) return;
  window.vrAccordionSteps = true;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  /** @param {HTMLDetailsElement} target @param {HTMLDetailsElement[]} rows */
  const openOnly = (target, rows) => {
    for (const row of rows) {
      if (row !== target && row.open) row.open = false;
    }
    if (!target.open) target.open = true;
  };

  /** @param {Element} accordion */
  const init = (accordion) => {
    if (accordion.dataset.vrStepsReady) return;
    accordion.dataset.vrStepsReady = 'true';

    const rows = () => Array.from(accordion.querySelectorAll('details.details'));
    const all = rows();
    if (!all.length) return;
    if (!all.some((row) => row.open)) all[0].open = true;

    for (const row of all) {
      const summary = row.querySelector('summary');
      // Opening any row (click, keyboard or hover) closes the others
      row.addEventListener('toggle', () => {
        if (row.open) openOnly(row, rows());
      });
      summary?.addEventListener('mouseenter', () => {
        if (canHover.matches) openOnly(row, rows());
      });
    }
  };

  const initAll = () => document.querySelectorAll('.accordion--vr-steps').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-run after a section re-renders, open a selected step
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target instanceof Element ? event.target.closest('details.details') : null;
    const accordion = details?.closest('.accordion--vr-steps');
    if (details && accordion) openOnly(details, Array.from(accordion.querySelectorAll('details.details')));
  });
})();
